import { RUB } from '../../../utils/char';
import { useTranslation } from '../../../utils/useTranslation';
import { Tooltip } from '../../feedback/Tooltip';
import { IconClock } from '../../icon/IconClock';
import { IconDeclinedFilled } from '../../icon/IconDeclinedFilled';
import { IconLimited } from '../../icon/IconLimited';
import { IconProductWarning } from '../../icon/IconProductWarning';
import { IconText } from '../../icon/IconText';
import { DataTestId } from '../../layout/DataTestIdWrapper';
import { Typography } from '../../typography/Typography';
import { CurrencyIcon } from '../ProductMonetization/styles';
import { PostStatus } from '../constants';
import { DeclinedReason } from '../types';
import { IconWrapper, MonetizationIconWrapper } from './styles';
import { PostCardStatusProps } from './types';

export const PostCardStatus: React.FC<PostCardStatusProps> = ({ post, ...other }) => {
    const t = useTranslation();

    const { status, declinedReason, monetizationEnabled } = post;

    if (status === PostStatus.MODERATION) {
        return (
            <Tooltip
                trigger={
                    <IconWrapper cursor="help" {...other}>
                        <IconClock
                            size={20}
                            color="white"
                            dataTestId={DataTestId.MODERATION_STATUS_CLOCK}
                        />
                    </IconWrapper>
                }
            >
                <Typography variant="caption" color="var(--color-invert)">
                    {t('Пост на модерации')}
                </Typography>
            </Tooltip>
        );
    }

    if (status === PostStatus.LIMITED) {
        return (
            <Tooltip
                trigger={
                    <IconWrapper background="var(--color-warning)" cursor="help" {...other}>
                        <IconLimited size={20} color="#FFFFFF" />
                    </IconWrapper>
                }
            >
                <Typography variant="caption" color="var(--color-invert)">
                    {t('Пост виден только в профиле')}
                </Typography>
            </Tooltip>
        );
    }

    if (declinedReason === DeclinedReason.NEED_PRODUCT) {
        return (
            <Tooltip
                trigger={
                    <IconWrapper background="var(--color-danger)" cursor="help" {...other}>
                        <IconProductWarning size={20} color="var(--control-secondary-blur-color)" />
                    </IconWrapper>
                }
            >
                <Typography variant="caption" color="var(--color-invert)">
                    {t('Нужно добавить товар')}
                </Typography>
            </Tooltip>
        );
    }

    if (status === PostStatus.DECLINED) {
        return (
            <Tooltip
                trigger={
                    <IconWrapper background="var(--color-danger)" cursor="help" {...other}>
                        <IconDeclinedFilled size={20} color="var(--control-secondary-blur-color)" />
                    </IconWrapper>
                }
            >
                <Typography variant="caption" color="var(--color-invert)">
                    {t('Пост отклонен')}
                </Typography>
            </Tooltip>
        );
    }

    if (status === PostStatus.DRAFT) {
        return (
            <Tooltip
                trigger={
                    <IconWrapper background="var(--badge-draft)" cursor="help" {...other}>
                        <IconText size={20} color="var(--always-white)" />
                    </IconWrapper>
                }
            >
                <Typography variant="caption" color="var(--color-invert)">
                    {t('Черновик поста')}
                </Typography>
            </Tooltip>
        );
    }

    if (monetizationEnabled) {
        return (
            <Tooltip
                trigger={
                    <MonetizationIconWrapper cursor="help" {...other}>
                        <CurrencyIcon
                            width={14}
                            height={14}
                            backgroundColor="var(--always-black)"
                            color="var(--always-white)"
                        >
                            {RUB}
                        </CurrencyIcon>
                    </MonetizationIconWrapper>
                }
            >
                <Typography variant="caption" color="var(--color-invert)">
                    {t('Есть монетизация')}
                </Typography>
            </Tooltip>
        );
    }

    return null;
};
